import { render, staticRenderFns } from "./IndicatorBarchart.vue?vue&type=template&id=1b26ce15&"
import script from "./IndicatorBarchart.vue?vue&type=script&lang=js&"
export * from "./IndicatorBarchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports